import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Recipes from './pages/Recipes';
import Safety from './pages/Safety';
// import Docs from './pages/Docs';
import Roadmap from './pages/Roadmap';
import Pricing from './pages/Pricing';
import Installation from './pages/Installation';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import About from './pages/About';
import Status from './pages/Status';
import Changelog from './pages/Changelog';
import Blog from './pages/Blog';
import WhyTweExists from './pages/blog/WhyTweExists';
import AboutTheJourney from './pages/blog/AboutTheJourney';
import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/recipes" element={<Recipes />} />
          <Route path="/safety" element={<Safety />} />
          {/* <Route path="/docs" element={<Docs />} /> */}
          <Route path="/installation" element={<Installation />} />
          <Route path="/roadmap" element={<Roadmap />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/about" element={<About />} />
          <Route path="/status" element={<Status />} />
          <Route path="/changelog" element={<Changelog />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/why-twe-exists" element={<WhyTweExists />} />
          <Route path="/blog/about-the-journey" element={<AboutTheJourney />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;